/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
import type { IconSVGProps } from '../../components/icon/Icon'
const train = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1.877 12.189A.877.877 0 0 1 1 11.312v-8.69A.622.622 0 0 1 1.622 2h5.756m0 0v5.5m0-5.5h.933m-.933 5.5h6.378A1.244 1.244 0 0 1 15 8.744v2.2a1.244 1.244 0 0 1-1.244 1.245H13.5M7.378 7.5H3.5v-3h3.878m-2.49 8.233a1.556 1.556 0 1 1-3.11 0 1.556 1.556 0 0 1 3.11 0Zm4.356 0a1.556 1.556 0 1 1-3.11 0 1.556 1.556 0 0 1 3.11 0Zm4.356 0a1.556 1.556 0 1 1-3.111 0 1.556 1.556 0 0 1 3.111 0Z"
    />
  </svg>
)
export default train
